// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"de1602ad4099f872a9f8","883":"bca2dd2b95cbe469f199"}[chunkId] + ".js";
};